import(/* webpackMode: "eager", webpackExports: ["signOut"] */ "/usr/src/app/node_modules/next-auth/react.js");
;
import(/* webpackMode: "eager", webpackExports: ["DashboardScreen"] */ "/usr/src/app/src/screens/dashboard/DashboardScreen.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LandingPageScreen"] */ "/usr/src/app/src/screens/landing-page/LandingPageScreen.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/types/Institution/domain/institution.ts");
